import O1HD from "../../../engines/gameEngine";
import { CharadeInterface } from "../../Game/Config/CharadeLevelConfig";
import { BUNDLE_SMALL_NAME, getOneBundleByInstant } from "../BundleResourceConfig";
import Level_Charade from "./Level_Charade";

const {ccclass, property} = cc._decorator;

@ccclass
export default class Level_Charade_ChatItem extends cc.Component {

    @property({type:cc.Node,displayName:"文本"})
    chatNode:cc.Node = null;

    @property({type:cc.Node,displayName:"emoji或者文字Content"})
    chatSp:cc.Node = null;

    @property({type:cc.Node,displayName:"头像"})
    head:cc.Node = null;

    @property({type:cc.Node,displayName:"emoji表情"})
    emojiItem:cc.Node = null;

    @property({type:cc.Node,displayName:"答案Content"})
    answerContent:cc.Node = null;
    
    @property({type:cc.Node,displayName:"答案Item"})
    answerItem:cc.Node = null;

    charadeInteface:CharadeInterface = null;

    currentAnswer:string = "";

    levelScript:Level_Charade = null;

    rotation:number = 0;

    setDate(date:CharadeInterface,levelScript:Level_Charade,rotation:number){
        this.rotation = rotation;
        this.levelScript = levelScript;
        this.charadeInteface = date;
        let current:string[] = date.chats;
        for(let i = 0;i<current.length;i++){
            let str = current[i];
            this.loadOneChat(str);
        }
        this.scheduleOnce(this.loadAnswersItem);
    }

    loadOneChat(str:string){
        if(str.includes("#")){
            this.loadEmojiNode(str);
        }else{
            this.loadOnechatNode(str);
        }
    }
    
    loadEmojiNode(str:string){
        let assetName = str.substring(1);
        let node = cc.instantiate(this.emojiItem);
        let bundle = getOneBundleByInstant(BUNDLE_SMALL_NAME.codeBreakGameBundle);
        bundle.load(`Img/Game/emoji/${assetName}`,cc.SpriteFrame,(err,assets:cc.SpriteFrame)=>{
            if(err){
                console.error("加载emoji表情出错");
                return;
            }
            node.getComponent(cc.Sprite).spriteFrame = assets;
        });
        node.y = 0;
        this.chatSp.addChild(node);
    }
    
    loadOnechatNode(str:string){
        let node = cc.instantiate(this.chatNode);
        let lb:cc.Label = node.getComponent(cc.Label);
        lb.string = str;
        node.y = 0;
        this.chatSp.addChild(node);
    }

    loadAnswersItem(){
        let str = this.charadeInteface.answer;
        for(let i = 0;i<str.length;i++){
            let node = cc.instantiate(this.answerItem);
            node.y = 0;
            this.answerContent.addChild(node);
        }
        this.scheduleOnce(()=>{
            let width = this.chatSp.width+10;
            let interver:number = 0;
            if(this.answerContent.width > width){
                interver = (this.answerContent.width - width)*.5;
            }
            let halfWidth = width*0.5+interver+this.head.width;
            this.answerContent.x = this.rotation == 0 ? halfWidth :  -halfWidth;
        });
    }

    addOneAnswer(answer:string){
        if(this.currentAnswer.length >= this.charadeInteface.answer.length){
            O1HD.getModules().uiControlModule.showMessageBox("答案已经填充满了");
            return false;
        }
        this.currentAnswer += answer;
        let length = this.currentAnswer.length;
        // console.log(this.currentAnswer,length,"?????????")
        let node = this.answerContent.children[length-1];
        let lb = node.getChildByName("lb").getComponent(cc.Label);
        lb.string = answer;
        return true;
    }   

    splitOneAnswer(){
        if(this.currentAnswer.length<1){
            O1HD.getModules().uiControlModule.showMessageBox("请先填充答案");
            return false;
        }
        let length = this.currentAnswer.length;
        let node:cc.Node = this.answerContent.children[length-1];
        let lb = node.getChildByName("lb").getComponent(cc.Label);
        lb.string = "";
        this.currentAnswer = this.currentAnswer.substring(0,this.currentAnswer.length-1);
        return true;
    }

    checkAnswerIsVaild(){
        return this.currentAnswer == this.charadeInteface.answer;
    }

    splitAllAnswer(){
        this.answerContent.children.forEach((n:cc.Node)=>{
            let node:cc.Node = n;
            let lb = node.getChildByName("lb").getComponent(cc.Label);
            lb.string = "";
            this.currentAnswer = this.currentAnswer.substring(0,this.currentAnswer.length-1);
        });
    }

}
